import { render, staticRenderFns } from "./NoDragImage.vue?vue&type=template&id=030450a0&scoped=true&"
import script from "./NoDragImage.vue?vue&type=script&lang=js&"
export * from "./NoDragImage.vue?vue&type=script&lang=js&"
import style0 from "./NoDragImage.vue?vue&type=style&index=0&id=030450a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030450a0",
  null
  
)

export default component.exports